<template>
  <div class="loaded">
    <slot />
  </div>
</template>
<script>
</script>

